<div
  *ngIf="domOpen"
  #overlayRoot
  class="v2-get-binders"
  [class.v2-get-binders--closing]="isClosing"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="
    giftInfoOnly ? ('GET_BINDERS' | translate) : ('GET_BINDERS_HEADER' | translate)
  "
>
  <button
    type="button"
    class="v2-rpc-floating-close"
    (click)="dismissPage()"
    [class.v2-rpc-floating-in]="headerReveal"
    [attr.aria-label]="'BUTTON_CLOSE' | translate"
  >
    ×
  </button>

  <div
    class="v2-rpc-title-pill"
    [class.v2-rpc-floating-in]="headerReveal"
    aria-hidden="true"
  >
    {{
      giftInfoOnly ? ('GET_BINDERS' | translate) : ('GET_BINDERS_HEADER' | translate)
    }}
  </div>

  <div class="v2-rpc-body">
    <div class="v2-rpc-scroll-outer v2-request-phys-col-scroll">
      <div
        class="manage-wrapper v2-req-phys-wrap v2-gb-wrap"
        [class.opened]="contentReveal"
        [class.loaded]="contentReveal"
      >
        <main class="v2-rpc-scroll">
          <ng-container *ngIf="giftInfoOnly">
            <div class="v2-gb-inner v2-gb-inner--gift">
              <div class="v2-rpc-item">
                <section class="v2-gb-panel v2-gb-panel--gift-info">
                  <div class="v2-gb-gift-stack">
                    <div class="v2-gb-intro-image">
                      <div class="v2-gb-image-frame">
                        <img
                          class="v2-gb-intro-img"
                          [src]="
                            collectionIconPath
                              ? collectionIconPath
                              : 'assets/images/logo-letter.svg'
                          "
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="v2-gb-gift-copy">
                      <p class="v2-gb-gift-message">{{ 'GIFT_BINDERS' | translate }}</p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </ng-container>

          <div *ngIf="!giftInfoOnly" id="modal-wraper" class="v2-gb-inner">
            <div class="v2-rpc-item">
              <section class="v2-gb-panel v2-gb-panel--intro">
                <div class="v2-gb-intro-row">
                  <div class="v2-gb-intro-image">
                    <div class="v2-gb-image-frame">
                      <img
                        class="v2-gb-intro-img"
                        [src]="
                          collectionIconPath
                            ? collectionIconPath
                            : 'assets/images/logo-letter.svg'
                        "
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="v2-gb-intro-copy">
                    <p class="v2-gb-lead">{{ 'GET_BINDERS_TEXT' | translate }}</p>
                    <p class="v2-gb-meta">
                      {{ 'EACH_BINDER_HAS_PREFIX' | translate }} {{ cardsPerBinder }}
                      {{ 'EACH_BINDER_HAS_SUFIX' | translate }}
                    </p>
                  </div>
                </div>
              </section>
            </div>

            <div class="v2-rpc-item">
              <section class="v2-gb-panel v2-gb-panel--qty-fields">
                <div class="v2-gb-qty-grid">
                  <app-btn
                    class="v2-gb-qty-btn"
                    [text]="
                      getBindersButtonOne === -1
                        ? ('LOADING' | translate)
                        : getBindersButtonOne.toString()
                    "
                    [type]="getBindersButtonOne === -1 ? 'disabled' : 'primary'"
                    (clicked)="setQty(getBindersButtonOne)"
                  ></app-btn>
                  <app-btn
                    *ngIf="getBindersButtonTwo > getBindersButtonOne"
                    class="v2-gb-qty-btn"
                    [text]="
                      getBindersButtonTwo === -1
                        ? ('LOADING' | translate)
                        : getBindersButtonTwo.toString()
                    "
                    [type]="getBindersButtonTwo === -1 ? 'disabled' : 'primary'"
                    (clicked)="setQty(getBindersButtonTwo)"
                  ></app-btn>
                  <app-btn
                    *ngIf="getBindersButtonThree > getBindersButtonTwo"
                    class="v2-gb-qty-btn"
                    [text]="
                      getBindersButtonThree === -1
                        ? ('LOADING' | translate)
                        : getBindersButtonThree.toString()
                    "
                    [type]="getBindersButtonThree === -1 ? 'disabled' : 'primary'"
                    (clicked)="setQty(getBindersButtonThree)"
                  ></app-btn>
                  <app-btn
                    *ngIf="getBindersButtonFour > getBindersButtonThree"
                    class="v2-gb-qty-btn"
                    [text]="
                      getBindersButtonFour === -1
                        ? ('LOADING' | translate)
                        : getBindersButtonFour.toString()
                    "
                    [type]="getBindersButtonFour === -1 ? 'disabled' : 'primary'"
                    (clicked)="setQty(getBindersButtonFour)"
                  ></app-btn>
                </div>

                <div class="v2-gb-field-grid">
                  <div class="v2-gb-field">
                    <label class="v2-gb-label" for="gb-num-binders">{{ 'QUANTITY' | translate }}</label>
                    <input
                      id="gb-num-binders"
                      class="v2-gb-input"
                      type="number"
                      inputmode="numeric"
                      [(ngModel)]="num_binders"
                      [placeholder]="'QUANTITY' | translate"
                      (input)="evalValuesNumberBinders()"
                    />
                  </div>
                  <div class="v2-gb-field">
                    <span class="v2-gb-label">{{ 'TOTAL_VALUE' | translate }}</span>
                    <div class="v2-gb-readonly" aria-readonly="true">
                      {{ total_value != null ? total_value : '—' }}
                    </div>
                  </div>
                </div>

                <p
                  class="v2-gb-range-hint"
                  [class.v2-gb-range-hint--ok]="num_binders >= minBinders && num_binders <= maxBinders"
                >
                  Com {{ finMethod }}, pode comprar {{ minBinders }} a {{ maxBinders }} carteirinhas.
                </p>
              </section>
            </div>

            <div class="v2-rpc-item">
              <section class="v2-gb-panel v2-gb-panel--payment">
                <button
                  type="button"
                  class="v2-gb-pay-row"
                  *ngIf="isMBWayValid"
                  [class.v2-gb-pay-row--active]="finMethod === 'MBWAY'"
                  (click)="setFinMethod('MBWAY')"
                >
                  <span class="v2-gb-pay-radio" [attr.data-checked]="finMethod === 'MBWAY'"></span>
                  <span class="v2-gb-pay-label">MBWay</span>
                  <img
                    class="v2-gb-pay-logo"
                    src="/assets/images/mbway_logo.svg"
                    alt="MBWay"
                    *ngIf="!body.classList.contains('dark')"
                  />
                  <img
                    class="v2-gb-pay-logo"
                    src="/assets/images/dark_mbway_logo.svg"
                    alt="MBWay"
                    *ngIf="body.classList.contains('dark')"
                  />
                </button>

                <button
                  type="button"
                  class="v2-gb-pay-row"
                  *ngIf="isVisaValid"
                  [class.v2-gb-pay-row--active]="finMethod === 'VISA'"
                  (click)="setFinMethod('VISA')"
                >
                  <span class="v2-gb-pay-radio" [attr.data-checked]="finMethod === 'VISA'"></span>
                  <span class="v2-gb-pay-label">Credit/Debit Card</span>
                  <ion-icon name="card-outline" class="v2-gb-card-icon" aria-hidden="true"></ion-icon>
                </button>
              </section>
            </div>

            <div class="v2-rpc-item" *ngIf="finMethod === 'MBWAY'">
              <section class="v2-gb-panel">
                <label class="v2-gb-label" for="gb-msisdn">{{ 'GET_BINDERS_MBWAY_NUMBER' | translate }}</label>
                <input
                  id="gb-msisdn"
                  class="v2-gb-input v2-gb-input--tel"
                  type="tel"
                  inputmode="tel"
                  autocomplete="tel"
                  placeholder="Número Telemóvel"
                  [(ngModel)]="msisdn2"
                  (input)="evalValuesMSISDN()"
                />
                <label class="v2-gb-check">
                  <input
                    type="checkbox"
                    [(ngModel)]="storeMsisdn"
                    (change)="storeMsisdnPressed()"
                  />
                  <span>{{ 'GET_BINDERS_MBWAY_NUMBER_STORE' | translate }}</span>
                </label>
              </section>
            </div>

            <div class="v2-rpc-item" *ngIf="finMethod === 'VISA'">
              <section class="v2-gb-panel v2-gb-panel--note">
                <p class="v2-gb-note">{{ 'TRANSLATE_VISA_FIN_EXPLAIN' | translate }}</p>
              </section>
            </div>

            <div class="v2-rpc-item">
              <section class="v2-gb-panel v2-gb-panel--invoice">
                <label class="v2-gb-check v2-gb-check--invoice-toggle">
                  <input
                    type="checkbox"
                    [(ngModel)]="invoice_required"
                    (change)="invRequiredPressed()"
                  />
                  <span>{{ 'GET_BINDERS_REQUIRE_INVOICE' | translate }}</span>
                </label>

                <div class="v2-gb-invoice-expand" *ngIf="invoice_required">
                  <p class="v2-gb-invoice-note">
                    {{ 'GET_BINDERS_WILL_BE_SENT_BY_EMAIL_SEND' | translate }}
                  </p>
                  <label class="v2-gb-label" for="gb-nif">{{ 'GET_BINDERS_NIF' | translate }}</label>
                  <input
                    id="gb-nif"
                    class="v2-gb-input"
                    type="text"
                    inputmode="numeric"
                    placeholder="NIF"
                    [(ngModel)]="nif_for_invoice2"
                    (input)="NIFChanged()"
                  />
                  <label class="v2-gb-check">
                    <input type="checkbox" [(ngModel)]="storeNIF" (change)="storeNIFPressed()" />
                    <span>{{ 'GET_BINDERS_NIF_STORE' | translate }}</span>
                  </label>
                </div>
              </section>
            </div>

            <div class="v2-rpc-item">
              <app-btn
                class="v2-gb-submit v2-rpc-action-btn"
                [text]="'GET_BINDERS_GET' | translate"
                [type]="formValid ? 'primary' : 'disabled'"
                (clicked)="get()"
              ></app-btn>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>

  <div class="loader-parent" *ngIf="!giftInfoOnly && isLoading === true">
    <div #lottieLoader class="loader"></div>
  </div>
</div>
